import Glide from "@glidejs/glide";
import GLightbox from "glightbox";
import { forAllCallback } from "kwp-core/scripts/utils/helpers";

const block = () => {
    forAllCallback(".content-block.content-block--hero-front", (el) => {
        const elId = el.getAttribute("id");
        const bgs = document.querySelector(`#${elId} .backgrounds`);
        if (bgs) {
            new Glide(`#${elId} .backgrounds`, {
                type: "carousel",
                gap: 0,
                autoplay: 3000,
                hoverpause: false,
                keyboard: false,
                swipeThreshold: false,
                dragThreshold: false,
            }).mount();
        }

        const videoButtons = document.querySelectorAll(
            `#${elId} .button--video`
        );

        if (videoButtons) {
            videoButtons.forEach((button) => initVideo(button));
        }

        function initVideo(videoItem) {
            console.log(videoItem);
            const dataGallery = videoItem.dataset.gallery;
            const lightbox = GLightbox({
                selector: `[data-gallery="${dataGallery}"]`,
            });
            console.log(lightbox);
            lightbox.elements.forEach((item, key) => {
                item.node.addEventListener("click", (e) => {
                    lightbox.openAt(key);
                });
            });
        }
    });
};

export default block;
